import { ProductMappingType, ProductTypeResponseApi } from '../type'

export function productMapper(data: ProductTypeResponseApi): ProductMappingType {
  let imagUrl = ''

  // Adicionado "data.images?." para caso o array venha vazio ou null
  if (data.images && process.env.REACT_APP_AWS_S3_URL) {
    const imgFind = data.images
    imagUrl =
      imgFind.path.substring(7, imgFind.path.length) + '/' ===
        process.env.REACT_APP_AWS_S3_URL.substring(7, process.env.REACT_APP_AWS_S3_URL.length)
        ? imgFind.path + '/' + imgFind.imgsuffix
        : imgFind.path
  }

  const groups = data.productCustomerGroup?.map((group) => group.customerGroup?.name) || []

  return {
    id: data.id,
    code: data.code,
    name: data.name,
    // Adicionado "?." e fallback para caso o produto não tenha classificação
    category: data.classification?.name || '',
    img: imagUrl,
    status: data.status,
    group: groups,
    created: data.created,
    updated: data.updated,
  }
}
